module.exports = __webpack_public_path__ + "img/logo-dark2.41757efa.png";